<template>
    <div>

        <div class="finance-container">
            <div class="adaptation-block">
                <div class="adaptation-block__column">
                    <uzhnet-back-button @click="$router.push('/main')" />

                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('aboutMePage.header') }}
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div class="settings-form">
                        <div class="settings-form__inputs">
                            <uzhnet-input-line :disabled="!updateProfileFlag" v-model="userSettings.surname" placeholder="Додайте прізвище" :label="$t('aboutMePage.surname')" />
                            <uzhnet-input-line :disabled="!updateProfileFlag" v-model="userSettings.name" placeholder="Додайте ім'я" :label="$t('aboutMePage.name')" />
                            <uzhnet-input-line :disabled="true" v-model="userSettings.address" placeholder="" :label="$t('aboutMePage.address')" />
                            <uzhnet-input-line :disabled="!updateProfileFlag" v-model="userSettings.phone" placeholder="+380500000000" :label="$t('aboutMePage.phone')" />
                            <uzhnet-input-line :disabled="!updateProfileFlag" v-model="userSettings.password" placeholder="*****" :label="$t('aboutMePage.password')" contentType="password" />
                        </div>
                        <div class="settings-form__button">
                            <uzhnet-button-secondary v-if="!updateProfileFlag" @click="updateProfileFlag = true" class="w-92" :label="$t('aboutMePage.change')" />
                            <uzhnet-button v-else @click="saveSettings" class="w-92" :label="$t('aboutMePage.update')" />
                        </div>
                    </div>

                </div>
                <div class="adaptation-block__column desktop-mt-45">
                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('aboutMePage.settingHeader') }}
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div class="settings-options" style="margin: 0 auto; margin-top: 12px;">
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.cardAdded') }} <span v-if="store.cardNum && cardAdded">(****{{ store.cardNum.split('******')[1] }})</span></div>
                            <div class="settings-options_switch">
                                <uzhnet-switch v-model="cardAdded" />
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.internetAutoWriteOff') }}</div>
                            <div class="settings-options_switch">
                                <uzhnet-switch @click="updateWriteOffInternet" :modelValue="autoWriteOffInternet" />
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.tvAutoWriteOff') }}</div>
                            <div class="settings-options_switch">
                                <uzhnet-switch @click="updateWriteOffTv" :modelValue="autoWriteOffTv" />
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.pushAlerts') }}</div>
                            <div class="settings-options_switch">
                                <uzhnet-switch v-model="pushNotificationsFlag" />
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.telegramAlerts') }}</div>
                            <div class="settings-options_switch">
                                <uzhnet-switch v-model="telegramUser" />
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.contractWithUzhnet') }}</div>
                            <div @click="openLink('https://uzhnet.com/dogovir')" class="settings-options_switch">
                                <img src="@/assets/images/image-icon.svg" >
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.internetParameterMeasurementProtocol') }}</div>
                            <div @click="openLink('https://uzhnet.com/files/Internet_quality_test_protocol.pdf')" class="settings-options_switch">
                                <img src="@/assets/images/image-icon.svg" >
                            </div>
                        </div>
                        <div class="settings-options_option">
                            <div class="settings-options_label">{{ $t('aboutMePage.appLang') }}
                                <span :class="{
                                    'active': locale === 'en'
                                }">Eng</span>
                                /
                                <span :class="{
                                    'active': locale === 'ua'
                                }">Ukr</span></div>
                            <div class="settings-options_switch">
                                <uzhnet-switch v-model="localeSwitch" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import '@/assets/scss/settings-page.scss';
import { ref, onMounted, watch } from 'vue';
import { useMainStore } from '@/store/mainStore';
import { useRouter } from 'vue-router';
import { calculateFingerprint } from '@/services/fingerprint';
import { getAccounts, addAccount, updateAccount, getAccountByLogin } from '@/db/accountService';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import ApiManager from '@/services/ApiManager';
import { encryptMessage, decryptMessage } from '@/services/cryptoUtils';
import { useI18n } from 'vue-i18n';
import BotApiManager from '@/services/BotApiManager';

function base64UrlToUint8Array(base64UrlData) {
	const padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
	const base64 = (base64UrlData + padding)
		.replace(/-/g, '+')
		.replace(/_/g, '/');

	const rawData = window.atob(base64);
	const buffer = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		buffer[i] = rawData.charCodeAt(i);
	}
	return buffer;
}

function transformNotifications(data, t) {
    const months = [
        t('mounthes.january'),
        t('mounthes.february'),
        t('mounthes.march'),
        t('mounthes.april'),
        t('mounthes.may'),
        t('mounthes.june'),
        t('mounthes.july'),
        t('mounthes.august'),
        t('mounthes.september'),
        t('mounthes.october'),
        t('mounthes.november'),
        t('mounthes.december')
    ];

    const notificationsByMonth = {};
    if (!data?.notifications) {
        return notificationsByMonth;
    }
    data.notifications.forEach(notification => {
        const date = new Date(parseInt(notification.date) * 1000); // Перетворюємо дату
        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`; // Формат: "місяць рік"

        if (!notificationsByMonth[monthYear]) {
            notificationsByMonth[monthYear] = []; // Створюємо масив для цього місяця
        }

        notificationsByMonth[monthYear].push(notification); // Додаємо сповіщення
    });

    // sort notifications by date
    for (const month in notificationsByMonth) {
        notificationsByMonth[month].sort((a, b) => {
            return b.date - a.date;
        });
    }

    return notificationsByMonth;
}

function transformNotificationsEng(data, t) {
    const months = [
        t('mounthes.january'),
        t('mounthes.february'),
        t('mounthes.march'),
        t('mounthes.april'),
        t('mounthes.may'),
        t('mounthes.june'),
        t('mounthes.july'),
        t('mounthes.august'),
        t('mounthes.september'),
        t('mounthes.october'),
        t('mounthes.november'),
        t('mounthes.december')
    ];

    const notificationsByMonth = {};

    if (!data?.notifications_eng) {
        return notificationsByMonth;
    }

    data.notifications_eng.forEach(notification => {
        const date = new Date(parseInt(notification.date) * 1000); // Перетворюємо дату
        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`; // Формат: "місяць рік"

        if (!notificationsByMonth[monthYear]) {
            notificationsByMonth[monthYear] = []; // Створюємо масив для цього місяця
        }

        notificationsByMonth[monthYear].push(notification); // Додаємо сповіщення
    });

    // sort notifications by date
    for (const month in notificationsByMonth) {
        notificationsByMonth[month].sort((a, b) => {
            return b.date - a.date;
        });
    }

    return notificationsByMonth;
}

export default {
    name: 'SettingsPage',

    setup() {
        const store = useMainStore();

        const autoWriteOffInternet = ref(store.autoWriteOffInternet ? true : false);
        const autoWriteOffTv = ref(store.autoWriteOffTv ? true : false);
        const telegramUser = ref(false);

        const cardAdded = ref(store.cardNum ? true : false);

        const updateProfileFlag = ref(false);

        const router = useRouter();

        const { t, locale } = useI18n();
        const localeSwitch = ref(false);

        watch(cardAdded, async (newValue) => {
            const currentUserResponse = await getAccountByLogin(store.login);
            const currentUserData = currentUserResponse._data;
            const fingerprint = await calculateFingerprint();

            const decryptedToken = await decryptMessage(currentUserData.token, fingerprint, currentUserData.iv);

            if (newValue) {
                router.push('/payment-type')
            } else {
                await ApiManager.deleteUserCreditCard(decryptedToken)

                await updateCurrentUser(false, false)
            }
        })

        watch(localeSwitch, async (newValue) => {
            if (newValue) {
                locale.value = 'ua';
                localStorage.setItem('locale', 'ua');
                await ApiManager.updateUserLocale(store.user_id, 'ua')
            } else {
                locale.value = 'en';
                localStorage.setItem('locale', 'en');
                await ApiManager.updateUserLocale(store.user_id, 'en')
            }
        })

        const userSettings = ref({
            name: null,
            surname: null,
            address: null,
            phone: null,
            password: null
        })

        const updateFlag = ref(false)

        watch(telegramUser, async (newValue) => {
            if (updateFlag.value) {
                if (!newValue) {
                    telegramUser.value = true
                } else {
                    openLink('https://telegram.me/uzhnet_bot')
                }
            }
        }, { immediate: true })

        onMounted(async () => {
            const currentUserResponse = await getAccountByLogin(store.login);
            const currentUserData = currentUserResponse._data;
            const fingerprint = await calculateFingerprint();

            const decryptedToken = await decryptMessage(currentUserData.token, fingerprint, currentUserData.iv);
            //reverse btoa
            const token = atob(decryptedToken);

            const password = token.split(':')[1];

            userSettings.value = {
                name: store.userData.uname,
                surname: store.userData.ulastname,
                address: store.address_formatted,
                phone: store.userData.phone,
                password: password
            }

            telegramUser.value = await BotApiManager.isUserHasBot(store.user_id)

            const firebaseConfig = {
                apiKey: "AIzaSyACJnamLBW8O5mrAIwSui5hWzdfMCBRWAI",
                authDomain: "uzhnet-app-proto.firebaseapp.com",
                projectId: "uzhnet-app-proto",
                storageBucket: "uzhnet-app-proto.firebasestorage.app",
                messagingSenderId: "602939430643",
                appId: "1:602939430643:web:3600a11f8a0d5d48aec986"
            }
            initializeApp(firebaseConfig)

            localeSwitch.value = locale.value === 'ua'

            autoWriteOffInternet.value = +store.autowriteoff ? true : false
            autoWriteOffTv.value = +store.autowriteoff_tv ? true : false

            const currentToken = await getCurrentToken()
            pushNotificationsFlag.value = await ApiManager.isPushTokenUser(store.user_id, currentToken)

            updateFlag.value = true
        })

        const openLink = (link) => {
            window.open(link, '_blank');
        }

        const pushNotificationsFlag = ref(false)

        const applicationPublicKey = 'BA2QkofnIKkdjAQcp4BIVnalXeHijvmNwhfNk5XqtV_wG9V1mE4ZGCxLszRVGdLxmgq_oqxXu2pAuZX5XPz6h94'

        watch(pushNotificationsFlag, (newValue) => {
            processPushSwitch(newValue)
        })

        const updateWriteOffTv = async () => {
            autoWriteOffTv.value = !autoWriteOffTv.value
            await saveSettings(false, false)
        }

        const updateWriteOffInternet = async () => {
            autoWriteOffInternet.value = !autoWriteOffInternet.value
            await saveSettings(false, false)
        }

        const saveSettings = async (updatePage = true, updateDbAccount = true) => {
            const currentUserResponse = await getAccountByLogin(store.login);
            const currentUserData = currentUserResponse._data;
            const fingerprint = await calculateFingerprint();

            const decryptedToken = await decryptMessage(currentUserData.token, fingerprint, currentUserData.iv);

            await ApiManager.updateUserSettings(decryptedToken, {
                first_name: userSettings.value.name,
                last_name: userSettings.value.surname,
                phone: userSettings.value.phone,
                password: userSettings.value.password,
                autospis: autoWriteOffInternet.value ? 1 : 0,
                autospis_tv: autoWriteOffTv.value ? 1 : 0
            })

            const tokenWithNewPassword = store.login + ':' + userSettings.value.password
            const newTokenBtoA = btoa(tokenWithNewPassword)

            const encryptedData = await encryptMessage(newTokenBtoA, fingerprint)

            if (updateDbAccount) {
                await updateAccount(store.login, {
                    login: store.login,
                    address: store.address_formatted,
                    token: encryptedData.encrypted,
                    iv: encryptedData.iv
                })
            }

            updateProfileFlag.value = false

            await updateCurrentUser(updatePage, updateDbAccount)
            if (updatePage) {
                router.push('/main')
            }
        }

        const getCurrentToken = async () => {
            const messaging = getMessaging();
            const currentToken = await getToken(messaging, { vapidKey: applicationPublicKey })
            return currentToken
        }

        const deletePushToken = async () => {
            const token = await getCurrentToken()

            if (token) {
                await ApiManager.deletePushToken(store.user_id, token)
                localStorage.setItem('push_subscription_' + store.user_id, '0')
                localStorage.setItem('push_token_' + store.user_id, '')
            }
        }

        const setPushMessages = async () => {
            const messaging = getMessaging();

            const publicApplicationKey = base64UrlToUint8Array(applicationPublicKey)
            if ('serviceWorker' in navigator && 'PushManager' in window) {
                navigator.serviceWorker.ready
                    .then(registration => registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: publicApplicationKey }))
                    .catch(error => {
                        console.error('Ошибка при получении разрешения на Push-уведомления:', error);
                    });

                getToken(messaging, { vapidKey: applicationPublicKey }).then(async (currentToken) => {
                    if (currentToken) {
                        localStorage.setItem('push_subscription_' + store.user_id, '1')
                        localStorage.setItem('push_token_' + store.user_id, currentToken)

                        await ApiManager.setPushToken(store.user_id, currentToken)
                    }
                }).catch((err) => {
                    console.error('Failed to retrieve push token:', err.code);
                });
            } else {
                console.warn('Push-уведомления не поддерживаются в вашем браузере.');
            }
        }

        const processPushSwitch = (value) => {
            pushNotificationsFlag.value = value

            if (value) {
                setPushMessages()
            } else {
                deletePushToken()
            }
        }

        const updateCurrentUser = async (updatePage = true, updateDbAccount = true) => {
            const accounts = await getAccounts()
            const fingerprint = await calculateFingerprint()
            if (accounts.length) {
                const maybeAccount = await getAccountByLogin(store.login)
                let auth_token = ''
                try {
                    auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
                } catch (error) {
                    console.error('Unable to decrypt saved account:', error.message);
                    await dropAllAccounts()
                    router.push('/')
                    loading.value = false
                    return
                }

                const response = await ApiManager.getUserInfo(auth_token)
                const responseData = response.data

                if (updateDbAccount) {
                    if (maybeAccount) {
                        const encryptedData = await encryptMessage(auth_token, fingerprint)
                        await updateAccount(store.login, {
                            login: store.login,
                            address: responseData.address_formatted,
                            token: encryptedData.encrypted,
                            iv: encryptedData.iv
                        })
                    } else {
                        const encryptedData = await encryptMessage(auth_token, fingerprint)
                        await addAccount({
                            login: store.login,
                            address: responseData.address_formatted,
                            token: encryptedData.encrypted,
                            iv: encryptedData.iv
                        })
                    }
                }

                const clientInternetResponse = await ApiManager.getUserInternet(auth_token)
                const clientInternetData = clientInternetResponse.data

                const clientTvResponse = await ApiManager.getUserTv(auth_token)
                const clientTvData = clientTvResponse.data

                const allNotifications = await ApiManager.getAllNotifications(responseData.uid)

                const notificationsByMonth = transformNotifications(allNotifications.data, t)

                const notificationsByMonthEng = transformNotificationsEng(allNotifications.data, t)

                store.setCurrentNotificationsEng(notificationsByMonthEng)
                store.setCurrentNotifications(notificationsByMonth)

                store.setUserData(responseData.user_data)
                store.setUserInternetData(clientInternetData)
                store.setUserTvData(clientTvData)

                if (updatePage) {
                    router.push('/main')
                }
            }
        }

        return {
            autoWriteOffInternet,
            autoWriteOffTv,
            telegramUser,

            userSettings,
            updateProfileFlag,
            openLink,
            store,

            pushNotificationsFlag,

            saveSettings,

            localeSwitch,
            locale,

            updateWriteOffTv,
            updateWriteOffInternet,
            cardAdded
        }
    }
}
</script>

<style lang="scss">
    .settings-options_label > .active {
        color: #E0C522;
    }
</style>
